"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteElementByValue = deleteElementByValue;
exports.parentExists = exports.getParents = exports.pushUniqueElement = void 0;

var pushUniqueElement = function pushUniqueElement(array, element) {
  var result = array.slice(0);
  if (array.indexOf(element) < 0) result.push(element);
  return result;
}; // courtesy of stackoverflow
// https://stackoverflow.com/questions/3954438/how-to-remove-item-from-array-by-value


exports.pushUniqueElement = pushUniqueElement;

function deleteElementByValue(array) {
  var what,
      L = arguments.length,
      ax;

  while (L > 1 && array.length) {
    what = arguments[--L];

    while ((ax = array.indexOf(what)) !== -1) {
      array.splice(ax, 1);
    }
  }

  return array;
}
/*!
 * Get all of an element's parent elements up the DOM tree
 * (c) 2019 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  {Node}   elem     The element
 * @param  {String} selector Selector to match against [optional]
 * @return {Array}           The parent elements
 */


var getParents = function getParents(elem, selector) {
  // Setup parents array
  var parents = []; // Get matching parent elements

  while (elem && elem !== document) {
    // If using a selector, add matching parents to array
    // Otherwise, add all parents
    if (selector) {
      if (elem.matches(selector)) {
        parents.push(elem);
      }
    } else {
      parents.push(elem);
    } // Jump to the next parent node


    elem = elem.parentNode;
  }

  return parents;
}; // export const parentExists = (parents = [], specifiedParent = 'test') => {
//     let hasParent = false;
//     parents.forEach(parent => {
//         if (parent.id === specifiedParent || parent.classList.contains(specifiedParent)) hasParent = true;
//     });
//     return hasParent;
// };


exports.getParents = getParents;

var parentExists = function parentExists() {
  var parents = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var specifiedParent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['test'];
  var hasParent = false;
  parents.forEach(function (parent) {
    if (specifiedParent.includes(parent.id)) {
      hasParent = true;
    }

    if (parent.classList.length > 0) {
      parent.classList.forEach(function (klass) {
        specifiedParent.forEach(function (par) {
          if (klass === par) {
            hasParent = true;
          }
        });
      });
    }
  });
  return hasParent;
};

exports.parentExists = parentExists;